/**
 * EPIC-048 / 48.3 — Cache localStorage des favoris (§28.F.2).
 *
 * Persiste la dernière liste de favoris connue afin que le HTML de la
 * sidebar gauche réserve sa place dès le parse (script inline dans
 * `sidebar-account.html`) — sans cela, la section « Favoris » apparaît
 * une fois le fetch `/me/favorites` résolu et pousse les sections du
 * dessous vers le bas (layout shift visible §28.F.2).
 *
 * Forme stockée : `{ onboardingStage, savedAt, favorites: [{label, href}] }`.
 *   - `href` est précalculé (routePath + querystring trié) pour que le
 *     script inline n'ait aucune dépendance ES module.
 *   - `savedAt` (timestamp ms) sert au TTL défensif : on ignore un cache
 *     plus vieux que 30 jours pour éviter de pré-rendre des favoris
 *     supprimés depuis longtemps.
 *
 * La clé est purement applicative (`nm.favorites.v1`) — on la purge à la
 * déconnexion (`auth-logout`) et à chaque downgrade `onboardingStage`
 * détecté par `favorites-sidebar`.
 */

import { queryParamsToSearch } from "./normalize.js";

const KEY = "nm.favorites.v1";
const TTL_MS = 30 * 24 * 3600 * 1000;

export function writeCache(favorites, onboardingStage) {
  try {
    const simplified = (favorites || []).map((f) => ({
      label: f.label,
      href: `${f.routePath}${queryParamsToSearch(f.queryParams || {})}`,
    }));
    localStorage.setItem(
      KEY,
      JSON.stringify({
        onboardingStage,
        savedAt: Date.now(),
        favorites: simplified,
      }),
    );
  } catch (_e) {
    // localStorage indisponible (mode privé Safari, quota dépassé) → on
    // ignore : la sidebar continuera de s'afficher en mode async.
  }
}

export function clearCache() {
  try {
    localStorage.removeItem(KEY);
  } catch (_e) {
    // ignore
  }
}

export { KEY as CACHE_KEY, TTL_MS as CACHE_TTL_MS };
